/** Smart-filter identifiers and labels shown in the sidebar. Filtering and counts are server-owned. */

export type SmartFilterId =
  | 'favourites'
  | 'recently_added'
  | 'needs_review'
  | 'no_screenshot'
  | 'title_only'
  | 'uncategorized';

export interface SmartFilter {
  id: SmartFilterId;
  label: string;
}

export const SMART_FILTERS: SmartFilter[] = [
  { id: 'favourites', label: 'Favourites' },
  { id: 'recently_added', label: 'Recently added' },
  { id: 'needs_review', label: 'Needs review' },
  { id: 'no_screenshot', label: 'No screenshot' },
  { id: 'title_only', label: 'Title only' },
  { id: 'uncategorized', label: 'Uncategorized' },
];
